import { EFreelancerDutyType } from '../../types/app-account/freelancer';
import { ETempBusiness } from '../../types/contracts/contracts';
import { EIsRealName, ITaskAttachment } from './task';

export interface IDutyAcceptPackageParams {
  page: number;
  size: number;
  /** 任务id */
  dutyId: number;
  /** 任务类型 0:众包 1:撮合 */
  dutyType: EFreelancerDutyType;
  /** 人员姓名 */
  personName?: string;
  /** 身份证号 */
  personIdNumber?: string;
  /** 手机号 */
  personTel?: string;
  /** 合同状态 */
  contractStatus?: EAgreementStatusType;
  /** 合同类型 6:代征合同 7:撮合任务合同 */
  contractBusinessType?: ETempBusiness;
}

export interface IDutyAcceptPackage {
  /** 接包管理主表id */
  id: number;
  /** 任务id */
  dutyId: number;
  /** 个人名称 */
  personName: string;
  /** 手机号 */
  personTel: string;
  /** 银行账号 */
  personBank: string;
  /** 身份证号 */
  personIdNumber: string;
  /**
   * 接包方式
   * @description {@link EAcceptPackageType}
   */
  type: EAcceptPackageType;
  /**
   * 是否实名
   * @description {@link EIsRealName}
   */
  authStatus: EIsRealName;
  /** 关联订单 */
  orderInfo: string;
  /**
   * 合同签署状态
   * @description {@link EAgreementStatusType}
   */
  contractStatus: EAgreementStatusType;
  /** 交付次数(0:未上传) */
  deliveryCount: number;
  /** 代征合同预览地址 */
  collectContraetPreviewUrl: string;
  /** 代征合同id */
  collectContractld: number;
  /** 撮合任务合同预览地址 */
  matchContractPreviewUrl: string;
  /** 撮饦明嗌宵喃箋标任务合同id */
  matchContractld: number;
  /** 自顾者合同预览地址 */
  selfEmployedContractPreviewUrl: string;
  /** 自顾者合同id */
  selfEmployedContractId: number;
}

/** 合同签署状态 */
export enum EAgreementStatusType {
  /** 未签署 */
  NOT_SIGNED = 0,
  /** 已签署 */
  SIGNED = 1,
  /** 未完全签署*/
  NOT_COMPLETE = 2,
  /** 待生成 */
  NOT_GENERATED= 3,
}

export const agreementStatusLabel = {
  [EAgreementStatusType.NOT_SIGNED]: '未签署',
  [EAgreementStatusType.SIGNED]: '已签署',
  [EAgreementStatusType.NOT_COMPLETE]: '未全部签署',
  [EAgreementStatusType.NOT_GENERATED]: '待生成',
};

/** 接包方式 */
export enum EAcceptPackageType {
  /** 指派 */
  ASSIGN = 0,
  /** 报名 */
  SIGN_UP = 1,
}

export const acceptPackageTypeLabel = {
  [EAcceptPackageType.ASSIGN]: '指派',
  [EAcceptPackageType.SIGN_UP]: '报名',
};

export interface IdutyDeliverParams {
  /** 任务id */
  dutyId: number;
  /** 接包管理主表id */
  acceptId: number;
  /** 订单编号 */
  orderNo: string;
  /** 交付材料 */
  deliverFileList: ITaskAttachment[];
  /** 交付说明 */
  remark?: string;
}

export interface IDeliverItem {
  /** id */
  id: number;
  /** 订单编号 */
  orderNo: string;
  /** 交付日期(yyyy-MM-dd) */
  deliverTime: string;
  /** 交付说明 */
  remark: string;
  /**
   * 审核状态
   * @description {@link EDeliverStatus}
   */
  status: EDeliverStatus;
  /** 交付材料 */
  deliverFileList: ITaskAttachment[];
  /** 操作人 */
  creator: string;
}

/** 接包方式 */
export enum EDeliverStatus {
  /** 未审核 */
  UNAUDITED = 0,
  /** 审核通过 */
  APPROVED = 1,
}

export const deliverStatusLabel = {
  [EDeliverStatus.UNAUDITED]: '未审核',
  [EDeliverStatus.APPROVED]: '审核通过',
};

export const deliverStatusStyle = {
  [EDeliverStatus.UNAUDITED]: 'info',
  [EDeliverStatus.APPROVED]: 'success',
};

export interface IPersonOrderItem {
   /** 订单id */
   orderDetailId: number;
   /** 订单编号 */
   orderNo: string;
}

export interface IDutyDeliverDownloadReceiptParams {
  /** 订单id列表 */
  orderDetailIds: number[];
  /** 自由职业者名称 */
  personName: string;
}

export interface IDutyAcceptPackageContractViewItem {
  /** 合同id */
  id: number;
  /** 合同业务类型 6:代征合同 7:任务合同 */
  businessType: ETempBusiness;
  /** 合同状态 0:未生成 1:未签署 2:已签署 */
  contractStatus: number;
  /** 合同名称 */
  contractSubjectName: string;
}

export enum EAcceptPackageContractStatus {
  /** 未生成 */
  NOT_GENERATED = 0,
  /** 未签署 */
  NOT_SIGNED = 1,
  /** 已签署 */
  SIGNED = 2,
}

export const acceptPackageContractStatusLabel = {
  [EAcceptPackageContractStatus.NOT_GENERATED]: '未生成',
  [EAcceptPackageContractStatus.NOT_SIGNED]: '未签署',
  [EAcceptPackageContractStatus.SIGNED]: '已签署',
};
